import { jsx as _jsx } from "react/jsx-runtime";
export var IMAGE_CAPTURE_CORNER_POSITION;
(function (IMAGE_CAPTURE_CORNER_POSITION) {
    IMAGE_CAPTURE_CORNER_POSITION[IMAGE_CAPTURE_CORNER_POSITION["TOP_LEFT"] = 0] = "TOP_LEFT";
    IMAGE_CAPTURE_CORNER_POSITION[IMAGE_CAPTURE_CORNER_POSITION["TOP_RIGHT"] = 1] = "TOP_RIGHT";
    IMAGE_CAPTURE_CORNER_POSITION[IMAGE_CAPTURE_CORNER_POSITION["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
    IMAGE_CAPTURE_CORNER_POSITION[IMAGE_CAPTURE_CORNER_POSITION["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
})(IMAGE_CAPTURE_CORNER_POSITION || (IMAGE_CAPTURE_CORNER_POSITION = {}));
;
const ImageCaptureCornerSvg = ({ position, color = 'white', size = 45, fill = 'none' }) => {
    const cornerPositions = [
        {
            top: 0,
            left: 0,
            path: 'M42.5 2.24219L10.5 2.24219C6.08172 2.24219 2.5 5.82391 2.5 10.2422L2.49999 42.2422',
        },
        {
            top: 0,
            right: 0,
            path: 'M42.5 42.2422L42.5 10.2422C42.5 5.82391 38.9183 2.24219 34.5 2.24219L2.50001 2.24218',
        },
        {
            bottom: 0,
            right: 0,
            path: 'M2.5 42.2422L34.5 42.2422C38.9183 42.2422 42.5 38.6605 42.5 34.2422L42.5 2.24219',
        },
        {
            bottom: 0,
            left: 0,
            path: 'M2.50001 2.24219L2.5 34.2422C2.5 38.6605 6.08172 42.2422 10.5 42.2422L42.5 42.2422',
        },
    ];
    const { path, ...divProps } = cornerPositions[position];
    return (_jsx("div", { style: { position: 'absolute', zIndex: 100, ...divProps }, children: _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 45 45", fill: fill, children: _jsx("path", { d: path, stroke: color, strokeWidth: "4", strokeLinecap: "round" }) }) }));
};
export default ImageCaptureCornerSvg;
//# sourceMappingURL=ImageCaptureCornerSvg.js.map